let deleteButton =  require('../permission-buttons/DeleteButton.vue');
let updateButton =  require('../permission-buttons/UpdateButton.vue');
let addButton =  require('../permission-buttons/AddButton.vue');
let showButton =  require('../permission-buttons/ShowButton.vue');

export default {

    components: {
        'delete-button': deleteButton,
        'update-button': updateButton,
        'add-button': addButton,
        'show-button': showButton,
    },

    // needs prop for permissions
    props: {
        userPermissions: {
            type: Object,
            required: true,
        },
    },

};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/PermissionButtonsMixin.js